import React from 'react';
import {Button} from 'antd';

const StyleDarkControl = (props) => {
  const {setStyleMap,styleMap,mapgl,switchLayer} = props;
  const onClick =() => {
    if(mapgl){
      setStyleMap(process.env.REACT_APP_MAPBOX_STYLE_DARK);
      switchLayer(mapgl,process.env.REACT_APP_MAPBOX_STYLE_DARK);
    }
    
  }
  return(
    <Button 
      className={
        styleMap === process.env.REACT_APP_MAPBOX_STYLE_DARK ?  
        "mapboxgl-ctrl-active mapboxgl-ctrl-icon mapboxgl-ctrl-dark-mode" : 
        "mapboxgl-ctrl-icon mapboxgl-ctrl-dark-mode"
      } 
      onClick={onClick}> 
    </Button>
  )
}

export default StyleDarkControl;


